module.exports = function getResource(label, vars = []) {
    let resources = {
        modalTitleRegister: 'Register with Sephora',
        modalTitleCreate: 'Create an Account',
        biBenefitsDescription: 'Join to get access to these exclusive benefits:',
        freeBirthdayGift: 'Free<br>Birthday Gift',
        seasonalEvent: 'Seasonal<br>Savings Events',
        sampleRewards: 'Sample<br>Rewards'
    };

    return resources[label];
};
